/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */

import React from 'react';

class ComponentToPrint extends React.Component {
  static defaultProps = { children: [] };

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default ComponentToPrint;
